import React, { PropTypes } from 'react';
import partial from 'lodash/partial';

const NDACheckbox = ({ checked, updateAutoNDA }) => {
  const changed = partial(updateAutoNDA, !checked);
  return (<div className="checkbox auto-approve-checkbox">
    <input
      type="checkbox"
      onChange={changed}
      checked={checked}
      className="form-control"
      id="auto-approve"
    />
    <label className="form-label" htmlFor="auto-approve">
      Auto-approve creatives who sign NDA
    </label>
  </div>);
};

NDACheckbox.propTypes = {
  checked: PropTypes.bool,
  updateAutoNDA: PropTypes.func.isRequired,
};

export default NDACheckbox;



// WEBPACK FOOTER //
// ./project/components/nda_checkbox.jsx